import { SharingButtons } from '@/legacy/blocks/SharingButtons'
import { RelatedArticlesSection } from '@/legacy/components/BlogLayout/ArticleSections'
import { BlogReviewForm } from '@/legacy/components/BlogReviewForm'
import type { ProductKeys } from '@/legacy/components/Products/constants'
import type { CardArticleEntryData } from '@/legacy/models'

interface FooterSectionProps {
  relatedArticles: CardArticleEntryData[]
  product: ProductKeys
}

export default function FooterSection({ relatedArticles, product }: FooterSectionProps) {
  return (
    <>
      <SharingButtons variations="gray-icons" sharingLabel="Compartilhe o artigo" />
      <BlogReviewForm title={{ text: 'Este artigo foi útil?', tag: 'h3' }} />
      <RelatedArticlesSection articles={relatedArticles} product={product} />
    </>
  )
}
